import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useUserStore } from "../store/user.store";
import { getParentOrderHistory } from "../services/order.service";
// FIX: Import ParentOrder from central index to match service and OrderCard
import { ParentOrder } from "../types/index";
import { OrderCard } from "../components/order/OrderCard";
import { Spinner } from "../components/common/Spinner";
import { Button } from "../components/common/Button";
import { useNavigate } from "react-router-dom";

const OrderHistory: React.FC = () => {
  const { userProfile } = useUserStore();
  const navigate = useNavigate();

  const { data: orders = [], isLoading, isError } = useQuery<ParentOrder[]>(
    ["orderHistory", userProfile?.uid],
    () => getParentOrderHistory(userProfile?.uid || ""),
    { 
      enabled: !!userProfile?.uid,
      // Ensure the data is treated as ParentOrder[] from types/index
    }
  );

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[50vh]">
        <Spinner />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center py-10 text-red-500">
        Failed to load orders. Please try again.
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto py-8 px-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Your Orders</h1>
        <Button variant="secondary" onClick={() => navigate("/")}>
          Back to Menu
        </Button>
      </div>

      {orders.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-lg border border-dashed border-gray-200">
          <p className="text-gray-500 text-lg mb-4">You haven't placed any orders yet.</p>
          <Button onClick={() => navigate("/")}>Start Ordering</Button>
        </div>
      ) : (
        <div className="space-y-6">
          {orders.map((order: ParentOrder) => (
            <OrderCard key={order.id} order={order} />
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderHistory;